{
  "filters": {
    "creationDate": {
      "label": "Data di aggiunta",
      "formatter": {
        "input": "YYYY-MM-DD",
        "tag": "DD/MM/YYYY"
      },
      "periodSeparator": "a",
      "placeholder": "Seleziona un periodo"
    },
    "searchByNameOrVersion": "Ricerca per nome o versione",
    "range": "Tipo",
    "status": "Stato"
  },
  "newFirmware": "Nuovo firmware",
  "noFirmware": "Nessun firmware disponibile",
  "column": {
    "versionName": "Nome della versione",
    "type": "Tipo",
    "declination": "Gamma",
    "version": "Versione",
    "buildDate": "Data di generazione",
    "creationDate": "Data di aggiunta",
    "dateFormat": "DD/MM/YYYY alle HH:mm",
    "status": "Stato"
  },
  "actions": {
    "activate": {
      "label": "Attivare il firmware",
      "description": "Il firmware {name} sarà attivato."
    },
    "deactivate": {
      "label": "Disattiva il firmware",
      "description": "Il firmware {name} sarà disattivato."
    },
    "delete": {
      "label": "Eliminare il firmware",
      "description": "Il firmware {name} sarà eliminato.",
      "descriptionEmbedded": "Attualmente il firmware {name} è utilizzato in una campagna o in un’operazione. L’eliminazione del firmware influirà su queste operazioni."
    }
  },
  "status": {
    "ACTIVATED": "Attivo",
    "DEACTIVATED": "Inattivo"
  },
  "section": {
    "informations": {
      "title": "Informazioni del firmware"
    },
    "compatibility": {
      "title": "Compatibilità del firmware"
    },
    "complements": {
      "title": "Complementi"
    }
  },
  "validation": {
    "name": "Il nome del firmware è obbligatorio",
    "version": "La versione del firmware è obbligatoria"
  },
  "form": {
    "name": "Nome della versione",
    "description": "Descrizione",
    "version": "Versione",
    "range": "Tipo",
    "declination": "Gamma",
    "hardwareVersions": "Versioni hardware",
    "firmwareVersions": "Versioni firmware",
    "status": "Stato",
    "minimalCompatibleFirmwareVersion": "Versione firmware minima compatibile"
  },
  "upload": {
    "title": "Selezionare un file",
    "browse": "Sfogliare",
    "restrictionInformation": "Il firmware caricato deve essere un file .ZIP e deve pesare meno di 750 MB.",
    "validation": {
      "fileMandatory": "Il file deve essere uno .ZIP",
      "fileEmpty": "Il file .ZIP non deve essere vuoto",
      "fileSize": "La dimensione del file .ZIP deve essere inferiore a 750 MB"
    }
  },
  "firmwareInfo": {
    "compatibility": {
      "title": "Compatibilità",
      "description": "Il firmware selezionato ha le dipendenze seguenti:"
    },
    "equipmentTypeAttached": "Tipo di apparato collegato al firmware",
    "compatibleHardwareVersions": "Versioni hardware compatibili",
    "compatibleFirmwareVersions": "Versioni firmware compatibili"
  },
  "selected": "Firmware selezionato:"
}
